<div class="modal-content d-flex flex-column">
  <div class="modal-controls d-flex flex-row justify-content-end px-2 pt-2">
    <button type="button" class="close" (click)="onClose()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-header pt-lg-5 pt-3 pb-2 pb-lg-2">
    <div class="modal-title w-100">
      <div class="d-flex flex-column flex-md-row">
        <div class="d-flex flex-column header-label-cont my-lg-0 my-1">
          <h6 class="mb-0 header-label">Country Rankings</h6>
          <div class="d-flex flex-row align-items-center">
            <img src="https://cdn.pixalate.com/sellers/icons/apn/16x16/{{selectedSeller?.sellerId}}.jpg?cb"
              alt="{{selectedSeller?.sellerName}} Icon" onerror="this.src='/assets/icons/icon-72x72-grey.png'"
              class="mr-2 rounded seller-icon" />
            <span class="header-sublabel">{{ selectedSeller?.sellerName }}</span>
          </div>
        </div>
        <div class="header-controls-cont d-flex flex-row flex-wrap justify-content-md-end">
          <div class="d-flex flex-column mt-1 mb-2 mt-lg-0 mb-lg-0" *ngIf="selectedGroup === 'ctv'">
            <h6 class="mb-1 mb-sm-2 platforms-label">Platforms</h6>
            <div class="d-flex align-items-end">
              <div aria-label="Basic example" class="btn-group toggle-filter insight-toggle-filter" role="group">
                <ng-container *ngFor="let platform of platformFilters">
                  <button class="btn btn-secondary platform-btn d-flex align-items-center justify-content-center"
                    (click)="selectPlatform(platform.value)"
                    [ngClass]="{ active: this.selectedPlatform == platform.value }" type="button">
                    <span [innerHTML]="platform.label"></span>
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column my-lg-0 my-1">
            <h6 class="mb-1 mb-sm-2 regions-label">Regions</h6>
            <div>
              <ng-container *ngFor="let region of regionFilters">
                <button class="btn badge-pill mr-2 mb-1 mb-lg-0 px-lg-3 px-2 py-1"
                  [ngClass]="{'btn-primary' : this.regionFilter.includes(region)}"
                  (click)="selectRegion(region)">{{region}}</button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-body d-flex flex-column px-3 pb-3 pt-2 pt-lg-3">
    <div *ngIf="!noResult && !loadingData" class='results-table-cont d-flex flex-column'>
      <div class="results-table-header-cont">
        <table class='results-table header-table' fixed-table-header [ngClass]="{ sortable: currentConfig?.sortable }"
          *ngIf="gridData?.length > 0 && currentConfig?.gridHeaders | rankingsHeadersSort:currentConfig?.key:selectedGroup:(bp$ | async) as rankingGridHeaders">
          <thead>
            <tr>
              <ng-container *ngFor="let header of rankingGridHeaders; let last = last;">
                <ng-container *ngIf="!header.groups || (header.groups && header.groups.indexOf(selectedGroup) >= 0)">
                  <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                       (currentConfig?.notHideDataIfNA || (!currentConfig?.notHideDataIfNA && gridData[0][header.key] !== 'N/A')) &&
                        (header | showIf: currentMainFilterItems)">

                    <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                      <th class="{{header?.key}}" (click)="toggleSort(header)">
                        <app-ranking-gridheader-widget-container [header]="header"
                          [widgetComponent]="header?.headerWidgetComponent" [isLast]="last"
                          [selectedGroup]="selectedGroup">
                        </app-ranking-gridheader-widget-container>
                        <div class="sort-buttons {{header?.sort}}">
                          <i class="fa fa-caret-up"></i>
                          <i class="fa fa-caret-down"></i>
                        </div>
                      </th>
                    </ng-container>

                    <ng-template #spacer>
                      <th class="spacer" [style.width]="header?.format">&nbsp;</th>
                    </ng-template>

                  </ng-container>
                </ng-container>
              </ng-container>
            </tr>
          </thead>
        </table>
      </div>
      <div class="results-table-scroll-cont p-0">
        <table class='results-table body-table' [ngClass]="{ sortable: currentConfig?.sortable }">
          <tbody>
            <tr *ngFor="let dataItem of gridData | sortBy:sortHeader?.key:sortHeader?.sort">
              <ng-container *ngFor="let header of rankingGridHeaders; index as i">
                <ng-container *ngIf="!header.groups || (header.groups && header.groups.indexOf(selectedGroup) >= 0)">
                  <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                    <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || (!currentConfig?.notHideDataIfNA && gridData[0][header.key] !== 'N/A')) &&
                          (header | showIf: currentMainFilterItems)">
                      <td class="grid-data-item {{header.key}}">
                        <ng-container *ngIf="header?.widgetComponent">
                          <app-ranking-widget-container [data]="dataItem" [header]="header"
                            [reportId]="currentConfig?.reportId" [widgetComponent]="header.widgetComponent"
                            [selectedGroup]="selectedGroup" [mainFilterItems]="currentMainFilterItems"
                            [key]="header?.key">
                          </app-ranking-widget-container>
                        </ng-container>
                      </td>
                    </ng-container>
                  </ng-container>
                  <ng-template #spacer>
                    <td>&nbsp;</td>
                  </ng-template>
                </ng-container>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div *ngIf="loadingData" class="loading-data-placeholder">
      <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
    </div>
    <div *ngIf="noResult && !loadingData" class="no-data-placeholder">
      <p>There's no data for the selected regions. Try selecting a different region.</p>
    </div>
  </div>
</div>